import * as yup from "yup"

export const regex = {
  singleName: /^[a-zA-Zא-ת\s'-]*$/,
  phoneNumber: /^05\d([-]{0,1})\d{7}$/,
  allPhoneNumber: /^(?:\+972-?|0)(?:5\d|[2-9]|7\d)(?:-)?\d{7}$/,
  IDCompanyId: /^(?:[0-9]{5,9}|51\d{7})$/,
  IndividualID: /^(?:[0-9]{5,9}|51\d{7})$/,
  linkedin: /^(https:\/\/www\.linkedin\.com\/in\/.*)?$/,
  // eslint-disable-next-line no-useless-escape
  email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
}

export const invalid = {
  firstName: "יש להקליד אותיות בעברית או באנגלית בלבד וללא סימנים מיוחדים",
  lastName: "יש להקליד אותיות בעברית או באנגלית בלבד וללא סימנים מיוחדים",
  phoneNumber: "מספר נייד לא תקין",
  email: "כתובת האימייל אינה תקינה",
  allPhoneNumber: "מספר נייד לא תקין",
  description: "כאן צריך לכתוב בקצרה מדוע החלטת לשלוח פנייה",
  ID: 'מספר ת"ז/ח"פ לא תקין',
  IndividualID: 'מספר ת"ז/ח"פ לא תקין',
  linkedin: "הקישור שהוזן אינו תקין",
}

function isValidIsraeliID(id: string | number): boolean {
  let idStr = String(id).trim()
  if (idStr.length > 9 || idStr.length < 5 || isNaN(Number(idStr))) {
    return false
  }

  // Pad string with zeros up to 9 digits
  idStr = idStr.length < 9 ? ("00000000" + idStr).slice(-9) : idStr

  return (
    Array.from(idStr, Number).reduce((counter, digit, i) => {
      const step = digit * ((i % 2) + 1)
      return counter + (step > 9 ? step - 9 : step)
    }, 0) %
    10 ===
    0
  )
}

export const schemaCommon = {
  firstName: yup
    .string()
    .required("אנחנו צריכים לדעת מה השם שלך")
    .matches(regex.singleName, invalid.firstName)
    .max(25, invalid.firstName),
  lastName: yup
    .string()
    .required("צריך למלא גם שם משפחה")
    .matches(regex.singleName, invalid.lastName)
    .max(25, invalid.lastName),
  ID: yup
    .string()
    .required('אנא הקלד ת"ז/ח"פ')
    .matches(regex.IDCompanyId, invalid.ID),
  IndividualID: yup
    .string()
    .required('אנא הקלד ת"ז/ח"פ')
    .test("is-valid-israeli-id", invalid.IndividualID, (value) =>
      isValidIsraeliID(value),
    ),
  phoneNumber: yup
    .string()
    .required("מה מספר הטלפון שלך? צריך למלא, כדי שנחזור אליך")
    .matches(regex.phoneNumber, invalid.phoneNumber)
    .length(10, invalid.phoneNumber)
    .max(10, invalid.phoneNumber),
  city: yup.string().required("צריך לנסות להקליד את שם העיר שוב"),
  email: yup
    .string()
    .required("אנחנו צריכים לקבל את כתובת האימייל שלך")
    .matches(regex.email, invalid.email)
    .max(132, invalid.email),
  allPhoneNumber: yup
    .string()
    .required("מה המספר שלך? צריך למלא, כדי שנחזור אליך")
    .matches(regex.allPhoneNumber, invalid.allPhoneNumber)
    .max(10, invalid.allPhoneNumber),
  fax: yup
    .string()
    .matches(
      /^(?:(?:\+972-?|0)(?:5\d|[2-9]|7\d)(?:-)?\d{7}|^$)$/,
      invalid.allPhoneNumber,
    )
    .max(10, invalid.allPhoneNumber)
    .optional(),
  description: yup.string().required(invalid.description).max(4000, "הטקסט שהוזן ארוך מידי"),
  comments: yup.string().optional().max(4000, "הטקסט שהוזן ארוך מידי"),
  file: yup.string().required("required"),
  linkedin: yup.string().matches(regex.linkedin, invalid.linkedin),
  remarks: yup
    .string()
    .max(4000, "טקסט שהוזן ארוך מידי"),
}
